import { render, staticRenderFns } from "./skin-config.vue?vue&type=template&id=445bb22f&scoped=true&"
import script from "./skin-config.vue?vue&type=script&lang=js&"
export * from "./skin-config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445bb22f",
  null
  
)

export default component.exports